import { useAuth } from "@/hooks/useAuth";
import {
  isTeacher,
  hasAnyRole,
  isOrgAdminWithoutActingTeacher,
} from "@/utils/role-utils";
import { useAuthStore } from "@/store/useAuthStore";
import TeacherSpaceList from "../components/TeacherSpaceList";
import StudentSpaceList from "../components/StudentSpaceList";
import SpacesOrgAdminBlocker from "../components/SpacesOrgAdminBlocker";

export default function SpacesListPage() {
  const { user } = useAuth();
  const actingTeacherId = useAuthStore((s) => s.actingTeacherId);

  if (user && isOrgAdminWithoutActingTeacher(user.role, actingTeacherId)) {
    return <SpacesOrgAdminBlocker />;
  }

  if (
    isTeacher(user?.role) ||
    (hasAnyRole(user?.role, ["ORG_ADMIN"]) && actingTeacherId)
  ) {
    return <TeacherSpaceList />;
  }

  return <StudentSpaceList />;
}
